import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AppLocale } from "@/constants/locale";

export function useLanguageToggle() {
  const { i18n } = useTranslation();

  const toggleLanguage = useCallback(() => {
    void i18n.changeLanguage(
      i18n.language === AppLocale.En ? AppLocale.Hr : AppLocale.En,
    );
  }, [i18n]);

  const compactLabel = useMemo(
    () => (i18n.language === AppLocale.En ? "HR" : "EN"),
    [i18n.language],
  );

  return {
    language: i18n.language,
    toggleLanguage,
    /** Short label for tight layouts (sidebar). */
    compactLabel,
  };
}
